import { FeatureAvailabilityContext } from "@bokio/mobile-web-shared/core/contexts/FeatureAvailabilityContext/FeatureAvailabilityContext";

import type * as m from "@bokio/mobile-web-shared/core/model/model";
import type { ReactNode } from "react";

interface FeatureAvailibilityContextProviderProps {
	children: ReactNode;
	featureAvailability: m.Config.FeatureAvailabilityConfig;
}

export const FeatureAvailibilityContextProvider = ({
	children,
	featureAvailability,
}: FeatureAvailibilityContextProviderProps) => {
	return <FeatureAvailabilityContext value={featureAvailability}>{children}</FeatureAvailabilityContext>;
};
